var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.207,
    height: 6.207,
    viewBox: "0 0 6.207 6.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-cancel",
    "data-name": "Icon material-cancel",
    d: "M6.1,3a3.1,3.1,0,1,0,3.1,3.1A3.1,3.1,0,0,0,6.1,3ZM7.655,7.218l-.438.438L6.1,6.541,4.989,7.655l-.438-.438L5.666,6.1,4.552,4.989l.438-.438L6.1,5.666,7.218,4.552l.438.438L6.541,6.1Z",
    transform: "translate(-3 -3)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.1339e836607fd23883d42dd33364ab80.svg";
export { ForwardRef as ReactComponent };